import { ReactNode } from 'react';

import { Column } from 'components/Blocks';

import { LogoIcon } from 'components/Icons';

interface BaseSignInWrapperProps {
  children: ReactNode;
}

export function SignInWrapper({ children }: BaseSignInWrapperProps): JSX.Element {
  return (
    <div className="flex h-[100vh] items-center justify-center bg-primary px-5 dark:bg-card phone:px-2.5 small_phone:px-1">
      <div className="w-full max-w-[max(25%,450px)] rounded-lg bg-background p-8 text-center phone:p-6">
        <Column position="relative">
          <LogoIcon className="mx-auto block !h-20 phone:!h-16 small_phone:!h-12" />

          {children}
        </Column>
      </div>
    </div>
  );
}
